import React, {useEffect, useState} from 'react';
import dayjs from "dayjs";
import EmptyData from "../../../../resources/icon/empty-data.png";
import DetailLinkedPagination from "../../../../components/detailLayout/DetailLinkedPagination";
import {useSelector} from "react-redux";
import {getRequestRentalsForRentalAsset} from "../../../../api/lifecycle/rental/rentalRequestService";
import {useTranslation} from "react-i18next";
import {handleSetUserInfo} from "../../../../components/Utils/SimmsUtils";

const formatRentalPeriod = (start, end) => {
    if (!start || !end) {
        return "-";
    }
    return `${dayjs(start).format("MM-DD")} ~ ${dayjs(end).format("MM-DD")}`;
};

// 대여신청 이력
const RentalRequestHistoryList = ({rentalAssetId}) => {
    const [rentalHistories, setRentalHistories] = React.useState([]);
    const [pageable, setPageable] = useState({
        sort: "createdAt",
        desc: true,
        size: 5,
        totalElements: 0,
        totalPages: 0,
        page: 0
    });

    const refresh = useSelector(state => state.status.refreshRentalRequest);
    const {t} = useTranslation();

    useEffect(() => {
        handleCallData();
    }, [rentalAssetId, refresh, pageable.page]);

    const handleCallData = async () => {
        if (rentalAssetId) {
            const values = {rentalAssetId, pageable};
            await getRequestRentalsForRentalAsset(values, (data) => {
                setRentalHistories([...data.content]);
                setPageable((prev) => (
                    {...prev, totalElements: data.totalElements, totalPages: data.totalPages, page: data.number})
                );
            });
        }
    }

    return (
        <>
            <div className={'w-full'} style={{flex: 1, minHeight: 0}}>
                <div style={{height: "100%", overflowY: "auto"}}>
                    <table className="w-full table-fixed border-collapse">
                        <thead>
                        <tr>
                            <th className="w-[5%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>순서</span>
                            </th>
                            <th className="w-[10%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>신청상태</span>
                            </th>
                            <th className="w-[10%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>대여자</span>
                            </th>
                            <th className="w-[10%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>대여기간</span>
                            </th>
                            <th className="w-[10%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>대여 승인자</span>
                            </th>
                            <th className="w-[10%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>기간연장 승인자</span>
                            </th>
                            <th className="w-[10%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>기간연장일</span>
                            </th>
                            <th className="w-[10%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>반납 승인자</span>
                            </th>
                            <th className="w-[10%] text-left border-[1px] bg-[#f1f6f9] px-[1rem] py-[0.5rem] sticky top-0 z-[2]">
                                <span className={"input-label"}>신청일</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {rentalHistories.length > 0 ? (
                            <>
                                {rentalHistories.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className="min-w-[5px] w-[10px] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span
                                                className={"input-label"}>{(pageable.totalElements - index) - (pageable.page * 10)}</span>
                                        </td>
                                        <td className="min-w-[5px] w-[10px] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{t(`rent.${item.rentalType}`)}</span>
                                        </td>
                                        <td className="min-w-[5px] w-[10px] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{handleSetUserInfo(item.rentUser)}</span>
                                        </td>
                                        <td className="min-w-[5px] w-[10px] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label whitespace-nowrap"}>{formatRentalPeriod(item.startDate, item.endDate)}</span>
                                        </td>
                                        <td className="min-w-[5px] w-[10px] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{handleSetUserInfo(item.rentApprover)}</span>
                                        </td>
                                        <td className="min-w-[5px] w-[10px] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{handleSetUserInfo(item.extendApprover)}</span>
                                        </td>
                                        <td className="min-w-[5px] w-[10px] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{item.extendDate}</span>
                                        </td>
                                        <td className="min-w-[5px] w-[10px] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{handleSetUserInfo(item.returnApprover)}</span>
                                        </td>
                                        <td className="min-w-[5px] w-[10px] text-left border-[1px] px-[1rem] py-[0.5rem]">
                                            <span className={"input-label"}>{item.createdAt}</span>
                                        </td>
                                    </tr>
                                ))}
                            </>
                        ) : (
                            <tr className="border border-[#e2e8f0]" style={{height: "calc(100vh - 47rem)"}}>
                                <td className="w-full" colSpan={9}>
                                    <img src={EmptyData} className="w-[50px] m-auto mb-3"/>
                                    <div className={"text-center"}>데이터가 없습니다.</div>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
            {rentalHistories.length > 0 && (
                <DetailLinkedPagination
                    pageable={{
                        pageNumber: pageable.page,
                        totalPages: pageable.totalPages,
                        totalElements: pageable.totalElements,
                        pageSize: pageable.size,
                    }}
                    onPageChange={(next) => setPageable((prev) => ({...prev, page: next.pageNumber}))}
                />
            )}
        </>
    );
};

export default RentalRequestHistoryList;